module.exports = __webpack_public_path__ + "img/pnu_main2.05d93469.jpg";